/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState } from 'react';
import clsx from "clsx";
import customStyles from "../../../../assets/styles/customStyles";
import { Space, Modal, Row, Col, Image } from "antd";
import { Button } from "@mui/material";
import { Format1, Format2, EX01 } from "./Templates";
import { CustomSelect } from "../CustomSelect";
import CloseIcon from "../../../../assets/images/icon_menus/Close Button.svg";
import Artboard from "../../../../assets/images/currency/Artboard.png";
import { groupByMultiple, } from "../../../../helpers/utilities";
import { idNamingConversion, storageSetItem } from "../../../../helpers/utilities";
import html2pdf from "html2pdf.js";
import colorborder from "../../../../assets/images/colorborder.png";


const QuoteModal = React.forwardRef((props, ref) => {
  const { open, handleClose, link, history, title, details, format, type } = props;
  const [reportList, setReportList] = useState('');
  const [showNameDesc, setShowNameDesc] = useState('description');
  const pdfExportComponent = useRef(null);
  const classes = customStyles();
  const formatRef = useRef(null);
  const [loading, setLoading] = useState(false);
  let i = 0;

  useEffect(() => {
    if (details?.salesQuoteLineItems && details?.salesQuoteLineItems?.length > 0) {
      let lineDetails = groupByMultiple(details?.salesQuoteLineItems, 'address', 'area', 'city', 'pincode', 'state', 'country');
      setReportList(lineDetails);
    }
  }, [details]);


  // const handleDownload = (type = 'download') => {
  //   const sel = document.querySelectorAll(`.${classes.printFullPage}`);
  //   setLoading(true);
  //   for (let i = 0; i < sel.length; i++) {
  //     setTimeout(() => {
  //       const doc = new jsPDF('pt', 'px', 'a4');
  //       doc.addFileToVFS('Roboto-Regular.ttf', NormalFont);
  //       doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
  //       doc.addFileToVFS('Roboto-Medium.ttf', MediumFont);
  //       doc.addFont('Roboto-Medium.ttf', 'RobotoMedium', 'normal');
  //       doc.setFont("Roboto");
  //       doc.setFont("RobotoMedium");
  //       formatRef.current.checkHeight('', format);
  //       doc.html(sel[i], {
  //         margin: 10,
  //         autoPaging: "text",
  //         html2canvas: { scale: 0.433 }, // change the scale to whatever number you need,
  //         callback: async (doc) => {
  //           if (type === 'print') {
  //             doc.autoPrint();
  //             window.open(doc.output('bloburl'));
  //           } else {
  //             doc.save(`${title}`, { returnPromise: true });
  //           }
  //           setLoading(false);
  //         },
  //       });
  //       setTimeout(() => {
  //         formatRef.current.checkHeight('none');
  //       }, 100)
  //     })
  //   }
  // };

  const closeHandleCancel = () => {
    if (link !== '') {
      history.push(link, type);
    }
    handleClose(!open)
  };

  const previewFormat = (format, data, key) => {
    i += 1;
    switch (format) {
      case "quote-GST": return <Format1 ref={formatRef} showNameDesc={showNameDesc} list={data} count={i} sAddress={key} {...props} />;
      case "quote-no_GST": return <Format2 ref={formatRef} showNameDesc={showNameDesc} list={data} count={i} sAddress={key} {...props} />;
      case "EX01": return <EX01 ref={formatRef} showNameDesc={showNameDesc} list={data} count={i} sAddress={key} {...props} />;
      default: return <Format1 ref={formatRef} {...props} showNameDesc={showNameDesc} list={data} count={i} sAddress={key} />;
    }

  }

  const handleDownloadNew = (type = 'download') => {
    const element = pdfExportComponent.current;
    let iv = '';
    setLoading(true);
    html2pdf()
      .from(element)
      .set({
        margin: [10, 5, 10, 5], // [top, left, bottom, right]
        filename: "download.pdf",
        autoPaging: 'text',
        image: { type: "jpeg", quality: 1.0 },
        html2canvas: {
          scale: 3, // Increase scale for high resolution
          dpi: 300, // Ensure high DPI
          useCORS: true,
          letterRendering: true,
        }, // A4 width in pixels (≈ 210mm)
        pagebreak: { mode: ["css", "legacy"], before: '.page-break', avoid: '.no-break' },
        jsPDF: { unit: "mm", format: "a3", orientation: "portrait" },
      }).toPdf().get("pdf").then((pdf) => {
        // pdf.setFont("Roboto");
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          if (details?.serialNo) {
            iv = `Quotation Number : ${details?.serialNo}  - `;
          }
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          pdf.addImage(colorborder, "PNG", 5, 10, pageWidth - 10, pageHeight - 20); // x, y, width, height



          // pdf.text(`${iv} Pg. ${i} | ${totalPages}`, 220, 415);

          // pdf.setFontSize(10);
          // pdf.setTextColor(49, 119, 135);
          // pdf.text('* Powered by YOUNOTE', 5, 415);
          pdf.setFontSize(10);
          pdf.setTextColor(49, 119, 135);
          const rightTextWidth = pdf.getTextWidth(`${iv} Pg. ${i} | ${totalPages}`);
          pdf.text(`${iv} Pg. ${i} | ${totalPages}`, pageWidth - rightTextWidth - 5, pageHeight - 5);
          pdf.text('* Powered by YOUNOTE', 5, pageHeight - 5);
        }

        if (type === 'print') {
          pdf.autoPrint();
          const blob = pdf.output("blob");
          const formData = new FormData();
          formData.append("mode", "file");        // tell server you're sending PDF
          formData.append("file", blob, "file.pdf");
          fetch(process.env.REACT_APP_EXE_CONNECT_URL, {
            method: "POST",
            body: formData
          }).then(res => res.json()).then(data => { })
            .catch(err => {
              window.open(pdf.output('bloburl', "_blank"));
              console.error(err);
            });
          //window.open(pdf.output('bloburl', "_blank"));
        } else {
          pdf.save(`${title}`);
        }
        setLoading(false);
      });
  }

  const handleDisplayName = (data) => {
    storageSetItem('documentQuoteView', data);
    setShowNameDesc(data);
  }

  return (
    <Modal title="" open={open} footer={null}
      onCancel={() => closeHandleCancel()}
      width={1030}
      closable={false}
      className={clsx(classes.invoiceDesign, classes.removeUnderline)}>
      <Row gutter={75} className={classes.invoiceHeader}>
        <Col span={5}>
          <CustomSelect
            lableClasses={clsx(classes.textFieldLableColorCustom)}
            customClasses={clsx(classes.dropDownHighlight, classes.dropDownPointer)}
            details={[{ id: 'name', name: 'Name' }, { id: 'description', name: 'Description' }]}
            name={["Display"]}
            onChange={(e) => handleDisplayName(e.target.value)}
            defaultValue={showNameDesc}
            heads={['id', 'name']}
          />
        </Col>
        <Col span={5}>
        </Col>
        <Col span={14} className={clsx(classes.textAlignRight, classes.fontSize0)}>
          <Space direction="horizontal" align="center" size={[20, 20]}>
            <Button
              key="confirm"
              color="primary"
              id={idNamingConversion('Print', 'common', 'Button')}
              variant="contained"
              onClick={() => handleDownloadNew('print')}
              className={clsx(classes.AddMoreBtn, { [classes.loading]: loading })}
            >Print</Button>
            <Button
              key="save"
              color="primary"
              id={idNamingConversion('Download', 'common', 'Button')}
              variant="contained"
              onClick={() => handleDownloadNew()}
              className={clsx(classes.modalBtn, { [classes.loading]: loading })}
            >Download</Button>
            <Image id={idNamingConversion('Close', 'common', 'Icon')} onClick={() => closeHandleCancel()} src={CloseIcon} preview={false} className={classes.cursor} />
          </Space>
        </Col>
      </Row>
      <div ref={pdfExportComponent} style={{ fontFamily: "Roboto" }} className={classes.divToPrint} id={"divToPrint"}>
        {
          (process.env.NODE_ENV === 'development' || process.env.REACT_APP_PRODUCTION_MODE === 'development' || process.env.REACT_APP_PRODUCTION_MODE === 'qa') &&
          <div className={clsx(classes.divToPrintCommand, "divToPrintCommand")} >
            <Image
              src={Artboard}
              preview={false}
              className={classes.currencyIcon}
            />
          </div>
        }
        {
          reportList &&
          Object.keys(reportList).length > 0 && Object?.entries(reportList)?.map(([key, value]) =>
            previewFormat(details?.billFormat || 'quote-GST', value, key)
          )
        }
        {
          format &&
          previewFormat(format || 'quote-GST')
        }
      </div>
    </Modal>
  );
});

export default QuoteModal;
